import { useTranslation } from 'react-i18next'

import { useAddressStore } from '@features/shipping-methods'

import { ProductCarousel } from '@widgets/product-carousel'



import { IMAGE_SIZES, URL_CATEGORY_SALE_PRODUCTS } from '@shared/contants'
import { Product, useSaleProductsQuery } from '@shared/generated'

export default function ProductsCarouselSales () {
  const { t: tp } = useTranslation('product')
  const { shopId } = useAddressStore()

  const { data, loading } = useSaleProductsQuery({
    variables: {
      shopId: shopId,
      style: IMAGE_SIZES.TABLET,
      pager: {
        limit: 20,
        page: 1,
      },
    },
  })

  return (
    <>
      {data && (
        <ProductCarousel
          link={URL_CATEGORY_SALE_PRODUCTS}
          title={tp('sales')}
          products={data.saleProducts?.edges as Product[]}
          loading={loading}
          listName="Sale Products"
        />
      )}
    </>
  )
}
